import type { FC, PropsWithChildren, RefObject } from 'react'
import { useMemo, useContext, createContext } from 'react'

export interface ListStateContext {
  active?: string | number | null
  setActive?: (active: string | number | null, ref: RefObject<HTMLAnchorElement>) => void
}

const ListContext = createContext<ListStateContext | null>(null)

export const ListContextProvider: FC<PropsWithChildren<ListStateContext>> = ({ active, setActive, children }) => {
  const context = useMemo(() => ({ active, setActive }), [active, setActive])

  return <ListContext.Provider value={context}>{children}</ListContext.Provider>
}

export const useListContext = () => {
  const context = useContext(ListContext)
  if (!context) {
    throw new Error(`ListContext isn't available.`)
  }

  return context
}
